<template>
	<div class="inventory-list">
		<div class="title">
		库存项目
		<a v-if="getBtnByAuth('createInventoryPoj')" href="javascript:;" @click="increase">新增</a>
		</div>

		<ul class="menuList">
		<li
			:class="currentItem==index+1?'current':''"
			v-for="(item,index) in menuList"
			:key="item.id"
			@click="clickItem(item,index)"
		>{{item.name}}</li>
		<li v-if="Number(this.shopId) === -1" class="text-fail">请先进行门店切换操作！</li>
		</ul>
		<a-modal
		title="添加库存项目"
		:visible="visible"
		@ok="handleOk"
		:confirmLoading="confirmLoading"
		@cancel="handleCancel"
		>
		<a-form layout="inline" class="store-one-form">
			<a-form-item style="line-height:50px" label="库存项目名称">
				<a-input placeholder="请输入" v-model="storeName"/>
			</a-form-item>
			<br>
		</a-form>
		</a-modal>
	</div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
export default {
	name: "inventory-list",
	data() {
		return {
			visible: false,
			confirmLoading: false,
			storeName: "",
			storeList:[]
		};
	},
	computed: {
		...mapGetters(["currentItem", "menuList", "currnetId","shopId", "shopName"])
	},
	watch: {
		shopId(val) {
			if (Number(val) === -1) {
			}
		}
	},
	methods: {
		/**
		 * @increase 打开新增窗口
		 */
		increase() {
			this.visible = true;
			this.storeName= "";
		},
		/**
		 * @handleCancel 关闭新增窗口
		 */
		handleCancel() {
			this.visible = false;
		},
		/**
		 * @handleOk 校验、确认新增
		 */
		handleOk() {
			var flag=this.storeList.find(res => res.name===this.storeName);
			if(flag){
				this.$message.warning("场次已存在！");
				return false;
			}
			this.confirmLoading = true;
			this.addStore();
		},
		/**
		 * @addStore 新增场次类型
		 */
		addStore() {
			if (Number(this.shopId) === -1) {
				this.$message.warning('总平台不可操作');
				return false;
			}
			this.$api.totalPlatform.addStore({
				body: {
					shopId: this.shopId,
					name: this.storeName,
					stockCategory: 'TICKET',
					shopName: this.shopName,
				}
			}).then(res => {
				this.visible = false;
				this.confirmLoading = false;
				this.getStore();
			}).catch(err => {
				this.confirmLoading = false;
			});
		},
		/**
		 * 
		 */
		getStore() {
			if (!this.shopId) {
				return false;
			}
			if(String(this.shopId) === '-1'){
				this.$message.warn("请先进行门店切换操作！");
				this.storeList = [];
				this.$store.dispatch("setStoreList", []);
				this.$store.dispatch("setCurrnetId", 0);
				return false;
			}
			this.$api.totalPlatform.getStore({
				body: {
					shopId: this.shopId,
					stockCategory: 'TICKET'
				}
			}).then(res => {
				if (res) {
					this.storeList = res;
					this.$store.dispatch("setStoreList", res);
					this.getCurrentId();
					this.$emit("createInit");
				} else {
					this.storeList = [];
					this.$store.dispatch("setStoreList", []);
					this.getCurrentId();
					this.$emit("createInit");
				}
			});
		},
		clickItem(item, i) {
			this.$store.commit("setCurrentItem", i + 1);
			this.getCurrentId();
		},
		getCurrentId() {
			let id = this.menuList.length ? this.menuList[this.currentItem - 1].id : "";
			this.$store.dispatch("setCurrnetId", id);
		}
	},
	watch: {
		'shopId'(val) {
			this.getStore();
		}
	},
	mounted() {
		setTimeout(() => {
			if (this.shopId != -1) {
				this.getStore();
			}
		},500)
	}
};
</script>

<style lang="scss" scoped>
.title {
	line-height: 60px;
	border: 1px solid rgba(233, 233, 233, 1);
	a {
		color: $text-color-primary;
	}
}
.menuList {
	height: 758px;
	overflow-y: scroll;
	margin-bottom: 0px;
	li {
		line-height: 50px;
		cursor: pointer;
	}
	.current {
		border-right: 3px solid #ff6d33;
		background-color: #fff7f0;
	}
}
</style>
